import {BaseEntity} from '../../_helpers';
import {Expose} from 'class-transformer';

export class IncidentSource extends BaseEntity {
  @Expose()
  public name: String;
}
